<script setup>

import { ref } from "vue";

const showOneDayPrices = ref(false);

const props = defineProps({
    default: {},
    hasNamedPriceList: {
        type: Boolean,
        required: true,
    },
    namedPriceList: {
        type: Array,
        required: true,
    },
    basePrice: {
        type: String,
        required: true,
    },
});

const priceFixed = (price) => parseFloat(price).toFixed(2);

</script>

<template>
    <section>
        <div class="event-data" v-if="props.hasNamedPriceList">
            <div v-for="(item, idx) in props.namedPriceList" v-bind:key="idx">
                <div v-if="idx === 0 || showOneDayPrices" class="d-flex flex-row">
                    <div :class="['d-flex justify-content-end w-100 event-data', { 'mt-1': idx
                        !== 0} ]">
                        <div>{{ item.name }}&nbsp;-&nbsp;</div>
                        <div>£{{ priceFixed(item.value) }}</div>
                    </div>
                </div>
            </div>
            <div
                v-if="namedPriceList.length > 1 && !showOneDayPrices"
                class="see-all"
                @click="() => showOneDayPrices = true"
            >
                See all
            </div>
        </div>

        <div v-if="!props.hasNamedPriceList" className="event-data">
            £{{ priceFixed(basePrice) }}
        </div>
    </section>
</template>

<style scoped>
.event-data {
    font-weight: 400;
    color: #636066;
}

.mt-3r {
    margin-top: 3rem;
}

.see-all {
    font-weight: 600;
    font-size: 14px;
    line-height: 21px;
    color: #260045;
    text-align: end;
    margin-top: .5rem;
    cursor: pointer;
}
</style>
